import type { FC } from 'react'
import type { Space } from '@/features/photoset/types'
import { spaceNameToLabel } from '@/features/photoset/utils'
import { isWindows } from '@/helpers/utils'
import { type TKey, Trans } from '@/translations/i18n'

interface UndoMessageProps {
	operationType: 'allocation' | 'deallocation'
	onUndo: () => void
	spaceKeyName?: Space['key_name']
}

const operationTypeToLabel: Record<UndoMessageProps['operationType'], TKey> = {
	deallocation: 'photoset:allocation.image_deallocated_success',
	allocation: 'photoset:allocation.image_allocated_success'
}

export const UndoMessage: FC<UndoMessageProps> = ({
	operationType,
	onUndo,
	spaceKeyName
}) => {
	return (
		<p>
			<Trans
				components={{
					button: (
						<button
							className='cursor-pointer font-medium underline'
							onClick={onUndo}
							type='button'
						/>
					)
				}}
				i18nKey={operationTypeToLabel[operationType]}
				values={{
					shortcut: isWindows ? 'CTRL+Z' : '⌘Z',
					space: spaceKeyName ? spaceNameToLabel[spaceKeyName] : ''
				}}
			/>
		</p>
	)
}
